import moment from 'moment';
import { request } from '../../requests';
export default {
  namespaced: true,
  state: {
    project: {
      result: {},
      loading: false,
      timestamp: null
    },
    form: {
      data: {
        student_q1: false,
        student_q2: false,
        student_q3: false,
        student_q4: false,
        student_q5: false,
        staff_q1: false,
        staff_q2: false,
        staff_q3: false,
        staff_q4: false
      },
      errors: {},
      loading: false
    }
  },
  actions: {
    fetchRoster({
      commit
    }, {
      projectID
    }) {
      const url = `/tables/projects/${projectID}/rosters`;
      const method = 'GET';
      commit('setProjectLoading', true);
      return request({
        url,
        method
      }).done(responseData => {
        commit('setProjectResult', responseData.result);
        commit('setProjectTimestamp', moment());
      }).always(() => {
        commit('setProjectLoading', false);
      });
    },
    submitRoster({
      commit,
      getters
    }, {
      projectID,
      form
    }) {
      const url = `/forms/rosters/${projectID}/submit`;
      const data = {
        ...form
      };
      commit('setFormLoading', true);
      return request({
        url,
        data
      }).fail(response => {
        const responseData = response.responseJSON;
        if (responseData && responseData.errors) {
          commit('setFormErrors', responseData.errors);
        }
      }).always(() => {
        commit('setFormLoading', false);
      });
    }
  },
  getters: {
    isParentEmailsNone(state) {
      const data = state.form.data;
      if (!data.student_parent_emails) {
        return false;
      }
      return data.student_parent_emails === 'No';
    },
    isStaff(state) {
      const project = state.project.result;
      if (!project.picture_day_job_summary) {
        return false;
      }
      return state.project.picture_day_job_summary.some(i => {
        return i.includes('Staff') || i.includes('staff');
      });
    },
    projectDetails(state) {
      return state.project.result;
    },
    projectLoading(state) {
      return state.project.loading;
    },
    formErrors(state) {
      return state.form.errors;
    },
    formData(state) {
      return state.form.data;
    }
  },
  mutations: {
    setProjectResult(state, result) {
      if (result && result.portal_project) {
        state.form.data = {
          ...state.form.data,
          ...result.portal_project
        };
      }
      return state.project.result = result;
    },
    setProjectLoading(state, loading) {
      return state.project.loading = loading;
    },
    setProjectTimestamp(state, timestamp) {
      return state.project.timestamp = timestamp;
    },
    setFormErrors(state, errors) {
      return state.form.errors = errors;
    },
    setFormLoading(state, loading) {
      return state.form.loading = loading;
    },
    errorsReset(state, obj) {
      return state.form.errors = {};
    },
    formReset(state, obj) {
      return state.form.data = {
        opt_out: null,
        staff_photos: false
      };
    }
  }
};